import { img } from "../utils/cloudinaryImage.mjs";

export const spots = [
  {
    name: "新城海岸",
    i18n: {
      EN: {
        name: "Aragusuku Beach",
        description: "A shallow, crystal-clear beach popular for snorkeling, with a high chance of spotting sea turtles. The waves are calm, making it great for beginners too.",
      },
      中文: {
        description: "远浅且透明度高的人气浮潜海滩，遇见海龟的几率很高。海浪平稳，也很适合初学者。",
      },
      한국어: {
        name: "아라구스쿠 해안",
        description: "완만하고 투명도가 높은 바다가 펼쳐지며 바다거북을 만날 확률이 높은 인기 스노클링 스팟. 파도도 잔잔해 초보자에게도 추천합니다.",
      },
    },
    reading: "あらぐすく",
    description: "遠浅で透明度の高い海が広がり、ウミガメとの遭遇率が高い人気のシュノーケルスポット。波も穏やかで、初心者にもおすすめです。",
    image: img("v1788401954/%E6%96%B0%E5%9F%8E_uwlmv7.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "東 3m/s",
    clarity: "高い",
    beginner: "とても安心",
    snorkel: 5,
    sup: 4,
    dronePhoto: 1,
    photo: 1,
    underwaterPhoto: 4,
    facing: 0,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdBusy",
    crowdScore: 5,
    mapQuery: "新城海岸 宮古島",
    beginnerScore: 5,
    turtleScore: 5,
    parking:
      "無料駐車場：繁忙期は午前中には満車になることも。有料駐車場：無料駐車場がいっぱいになった場合、料金は1回2,000円です。繁忙期は10時を過ぎると駐車場の空き待ちで坂の上まで大渋滞が発生し、1時間ほど待つこともあります。",
    facilities: "トイレ：あり　シャワー：あり",
  },
  {
    name: "与那覇前浜ビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Yonaha Maehama Beach",
        description: "Miyakojima's iconic white sand beach stretching about 7km. The shallow, crystal-clear water is a highlight, but the open terrain makes it easy for wind to affect the sea. In the evening you can watch the sun set straight down to the horizon.",
      },
      中文: {
        description: "宫古岛最具代表性的约7公里白沙滩。远浅且透明度高的海水极具魅力，但地形开阔容易受风影响。傍晚可以笔直眺望夕阳沉入水平线。",
      },
      한국어: {
        name: "요나하 마에하마 비치",
        description: "미야코지마를 대표하는 약 7km에 이르는 하얀 모래사장. 완만하고 투명도 높은 바다가 매력이지만 탁 트인 지형이라 바람의 영향을 받기 쉽습니다. 저녁에는 수평선까지 곧게 지는 석양을 볼 수 있습니다.",
      },
    },
    description: "宮古島を代表する約7kmの白い砂浜が続くビーチ。遠浅で透明度の高い海が魅力ですが、開けた地形のため風の影響を受けやすいです。夕方は海に沈む夕日を水平線までまっすぐ見渡せます。",
    image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp", {
      width: 900,
      height: 520,
    }),
    youtubeId: "YXrCAi4lvCU",
    status: "caution",
    wave: "0.9m",
    wind: "南 7m/s",
    clarity: "高い",
    beginner: "やや注意",
    snorkel: 3,
    sup: 1,
    sunsetScore: 5,
    photo: 4,
    crowdLevel: "crowdBusy",
    facing: 270,
    categories: ["sunset", "beach"],
    mapQuery: "与那覇前浜ビーチ 宮古島",
  },
  {
    name: "長間浜",
    reading: "",
    i18n: {
      EN: {
        name: "Nagama Beach",
        description: "A sunset spot on the west side of Kurima Island, set in a calm, cove-like landscape. The setting sun reflects beautifully on the clear water, and on fine days you can slowly watch it sink into the horizon.",
      },
      中文: {
        description: "位于来间岛西侧，坐落在如海湾般平静的地形中的日落景点。夕阳映照在透明度高的海面上，天气好时可以慢慢欣赏夕阳沉入水平线的景色。",
      },
      한국어: {
        name: "나가마하마",
        description: "구리마섬 서쪽, 만처럼 잔잔한 지형에 펼쳐진 선셋 스팟. 투명도 높은 바다에 석양이 비치며, 맑은 날에는 수평선으로 지는 모습을 천천히 즐길 수 있습니다.",
      },
    },
    description: "来間島の西側、入り江のような穏やかな地形に広がるサンセットスポット。透明度の高い海に夕日が映り込み、天気がいい日は水平線に沈む様子をゆっくり眺められます。",
    image: img("v1788964873/長間浜_fbnkra.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "かなりいい",
    snorkel: 2,
    sup: 1,
    sunsetScore: 5,
    photo: 5,
    crowdLevel: "crowdQuiet",
    categories: ["sunset", "beach"],
    mapQuery: "長間浜 宮古島",
    beginnerScore: 2,
    turtleScore: 0,
    parking: "なし",
    facilities: "トイレ：なし　シャワー：なし",
  },
  {
    name: "サンセットビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Sunset Beach",
        description: "A sunset spot close to Hirara town, easy to stop by between activities. Enjoy the shallow, clear water reflecting the setting sun.",
      },
      中文: {
        description: "距离平良市区很近，行程间隙也方便顺路前往的日落景点。可以欣赏夕阳倒映在远浅、透明度高的海面上的美景。",
      },
      한국어: {
        name: "선셋 비치",
        description: "히라라 시가지에서 가까워 여행 중간에도 들르기 좋은 선셋 스팟. 완만하고 투명도 높은 수면에 석양이 비치는 풍경을 즐길 수 있습니다.",
      },
    },
    description: "平良市街地から近く、旅の合間にも立ち寄りやすいサンセットスポット。遠浅で透明度の高い水面に夕日が反射する景色が楽しめます。",
    image: img("v1788997646/サンセットビーチ_qfreee.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 0,
    sup: 1,
    sunsetScore: 4,
    photo: 4,
    dronePhoto: 3,
    crowdLevel: "crowdModerate",
    categories: ["sunset", "beach"],
    mapQuery: "宮古サンセットビーチ",
  },
  {
    name: "砂山ビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Sunayama Beach",
        description: "A popular beach marked by a rock arch beyond the sand dunes. The combination of clear water and sunset makes for beautiful photos, but watch your footing on the rocks and waves.",
      },
      中文: {
        description: "翻过沙丘后出现的岩石拱门是其标志的人气海滩。透明度高的海水与夕阳相映，非常上镜，但需注意脚下的岩石和海浪。",
      },
      한국어: {
        name: "스나야마 비치",
        description: "모래언덕을 넘으면 나타나는 바위 아치가 상징인 인기 해변. 투명도 높은 바다와 석양의 조합이 아름다워 사진이 잘 나오지만 발밑 바위와 파도에 주의가 필요합니다.",
      },
    },
    description: "砂丘を越えた先に現れる岩のアーチが目印の人気ビーチ。透明度の高い海と夕日の組み合わせが美しく写真映えしますが、足元の岩や波には注意が必要です。",
    image: img("v1788401954/%E7%A0%82%E5%B1%B1_fyzagc.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.5m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "波に注意",
    snorkel: 2,
    sup: 1,
    sunsetScore: 4,
    photo: 5,
    milkyWay: 5,
    driveMinutes: 10,
    crowdLevel: "crowdBusy",
    crowdScore: 4,
    beginnerScore: 4,
    facing: 0,
    categories: ["sunset", "snorkel", "beach"],
    mapQuery: "砂山ビーチ 宮古島",
  },
  {
    name: "伊良部大橋",
    reading: "",
    i18n: {
      EN: {
        name: "Irabu Bridge",
        description: "A spot where you can view the Irabu Bridge together with Miyako-blue waters. The base of the bridge is shallow and clear, and in the evening you can capture a dramatic scene where the bridge's silhouette overlaps with the setting sun.",
      },
      中文: {
        description: "可以将伊良部大桥与宫古蓝海景一同尽收眼底的景点。桥墩附近远浅且透明度高，傍晚可以拍到大桥剪影与夕阳重叠的壮观景色。",
      },
      한국어: {
        name: "이라부 대교",
        description: "이라부대교와 미야코블루의 바다를 함께 볼 수 있는 스팟. 다리 아래는 완만하고 투명도가 높으며, 저녁에는 다리 실루엣과 지는 석양이 겹치는 스케일감 있는 풍경을 담을 수 있습니다.",
      },
    },
    description: "伊良部大橋と宮古ブルーの海を一緒に眺められるスポット。橋のたもとは遠浅で透明度が高く、夕方は橋のシルエットと沈む夕日が重なるスケール感のある景色が撮れます。",
    image: "https://res.cloudinary.com/drxijtp8g/image/upload/v1788997090/DJI_20260830102147_0032_D_vrzrui.webp",
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 1,
    sup: 1,
    sunsetScore: 4,
    photo: 5,
    crowdLevel: "crowdQuiet",
    categories: ["sunset"],
    mapQuery: "伊良部大橋 宮古島",
  },
  {
    name: "17END",
    reading: "",
    i18n: {
      EN: {
        description: "A white sand beach that appears only at low tide, with beautifully clear water. Also popular as a spot to watch airplanes take off and land up close.",
      },
      中文: {
        description: "只有在退潮时才会出现的白色沙滩，海水透明度很高。也因能近距离看到飞机起降而广受欢迎。",
      },
      한국어: {
        description: "간조 때만 나타나는 하얀 모래사장과 투명도 높은 바다가 특징입니다. 비행기의 이착륙을 가까이서 볼 수 있는 스팟으로도 인기입니다.",
      },
    },
    description: "干潮時にのみ現れる白い砂浜と透明度の高い海。飛行機の離着陸を間近で見ることができるスポットとしても人気です。",
    image: "https://res.cloudinary.com/drxijtp8g/image/upload/v1788963220/DSC00440_bthqbi.webp",
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "かなりいい",
    snorkel: 1,
    sup: 1,
    sunsetScore: 5,
    photo: 5,
    dronePhoto: "prohibited",
    crowdLevel: "crowdModerate",
    categories: ["sunset", "beach"],
    mapQuery: "17END 宮古島",
  },
  {
    name: "ムスヌン浜",
    reading: "",
    i18n: {
      EN: {
        name: "Musunun Beach",
        description: "A quiet beach on Kurima Island with clear water and calm waves. Few visitors come here, so you can enjoy the sunset sinking into the horizon in peace.",
      },
      中文: {
        description: "位于来间岛的一处宁静海滩，透明度高、海浪平稳。游客较少，可以安静地欣赏夕阳沉入水平线。",
      },
      한국어: {
        name: "무스눈하마",
        description: "구리마섬에 있는 조용한 해변으로 투명도 높은 바다와 잔잔한 파도가 특징입니다. 찾는 사람이 적어 수평선으로 지는 석양을 차분히 즐길 수 있습니다.",
      },
    },
    description: "来間島にある静かな浜で、透明度の高い海と穏やかな波が特徴です。訪れる人が少なく、水平線に沈む夕日を落ち着いて楽しめます。",
    image: img("v1788997647/むすぬん浜_tdaclz.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "かなりいい",
    snorkel: 1,
    sup: 1,
    sunsetScore: 5,
    photo: 5,
    crowdLevel: "crowdQuiet",
    categories: ["sunset", "beach"],
    mapQuery: "ムスヌン浜 宮古島",
  },
  {
    name: "池間島北側",
    reading: "",
    i18n: {
      EN: {
        name: "North Ikema Island",
        description: "A beach on the north side of Ikema Island where the shallow terrain tends to keep waves calm. On days with the right wind direction, clarity is excellent, letting you snorkel in a quiet sea.",
      },
      中文: {
        description: "位于池间岛北侧的海滩，远浅地形使海浪容易保持平稳。风向合适的日子透明度非常高，可以在安静的海中享受浮潜。",
      },
      한국어: {
        name: "이케마섬 북쪽",
        description: "이케마섬 북쪽에 펼쳐진 해변으로 완만한 지형 덕분에 파도가 잔잔해지기 쉬운 것이 특징입니다. 바람 방향이 맞는 날에는 투명도가 매우 높아 조용한 바다에서 스노클링을 즐길 수 있습니다.",
      },
    },
    description: "池間島の北側に広がるビーチで、遠浅の地形により波が穏やかになりやすいのが特徴です。風向きが合う日は透明度がとても高く、静かな海でシュノーケルを楽しめます。",
    image: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.5m",
    wind: "東北東 3m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 4,
    sup: 4,
    categories: ["beach"],
    crowdLevel: "crowdQuiet",
    mapQuery: "池間島 宮古島",
  },
  {
    name: "シギラビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Shigira Beach",
        description: "Close to the Shigira Bay area with plenty of facilities, making it an easy choice for a first ocean outing. Shallow and clear with calm waves, it's also popular with families with small children.",
      },
      中文: {
        description: "靠近吉葛拉湾区，设施完善，适合初次海上体验。远浅、透明度高，海浪平稳，也深受带小孩家庭的欢迎。",
      },
      한국어: {
        name: "시기라 비치",
        description: "시기라베이 에어리어와 가까워 시설이 잘 갖춰져 있어 처음 바다 놀이를 하기에도 고르기 쉬운 해변입니다. 완만하고 투명도도 높으며 파도가 잔잔해 어린아이를 동반한 가족에게도 인기입니다.",
      },
    },
    description: "シギラベイエリアに近く施設が充実しているため、初めての海遊びにも選びやすいビーチ。遠浅で透明度も高く、波が穏やかなので小さな子ども連れにも人気です。",
    image: img("v1788401954/%E3%81%97%E3%81%8D%E3%82%99%E3%82%89_tghhsg.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.3m",
    wind: "東 2m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 4,
    sup: 3,
    dronePhoto: 1,
    photo: 1,
    facing: 180,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdBusy",
    crowdScore: 5,
    mapQuery: "シギラビーチ 宮古島",
    beginnerScore: 5,
    turtleScore: 5,
    parking: "有（1,000円・100台）",
    facilities: "トイレ：あり　シャワー：あり",
  },
  {
    name: "ワイワイビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Wai Wai Beach",
        description: "An artificial beach built alongside a fishing port. Enclosed by a breakwater into a bay, the waves are calm, and the shallow, clear water makes it great for snorkeling. Sea turtle encounters are common, making it good for beginners too.",
      },
      中文: {
        description: "与渔港一同建造的人工海滩。因防波堤围成海湾，海浪平稳，远浅且透明度高，适合浮潜。遇见海龟的几率也很高，适合初学者。",
      },
      한국어: {
        name: "와이와이 비치",
        description: "어항과 함께 조성된 인공 해변. 방파제로 둘러싸인 만이라 파도가 잔잔하고, 완만하며 투명도도 높아 스노클링에 좋습니다. 바다거북을 만날 확률도 높아 초보자에게도 추천합니다.",
      },
    },
    description: "漁港と共に造られた人工ビーチ。防波堤に囲まれた湾になっているので波が穏やかで、遠浅で透明度も高いシュノーケル向きのビーチ。ウミガメの遭遇率も高く、初心者にもおすすめです。",
    image: img("v1788401954/%E3%83%AF%E3%82%A4%E3%83%AF%E3%82%A4_ojkt0r.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 5,
    sup: 2,
    dronePhoto: 1,
    underwaterPhoto: 4,
    photo: 1,
    milkyWay: 5,
    facing: 180,
    sheltered: true,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdModerate",
    crowdScore: 4,
    mapQuery: "ワイワイビーチ 宮古島",
    beginnerScore: 5,
    turtleScore: 5,
    parking: "10台程駐車できる、無料の駐車場があります。繁忙期は満車になることも。",
    facilities: "トイレ・シャワー：なし",
  },
  {
    name: "サバウツガー",
    reading: "",
    i18n: {
      EN: {
        name: "Sabautsuga",
        description: "A rocky spot facing the sea toward Irabu Island, offering clear underwater views. The footing is rocky, so marine shoes are recommended.",
      },
      中文: {
        description: "可眺望伊良部岛方向海景的岩场景点，能享受透明度高的水中景色。地面多为岩石，建议穿溯溪鞋。",
      },
      한국어: {
        name: "사바우츠가",
        description: "이라부섬 쪽 바다를 바라보는 암초 지대 스팟으로 투명도 높은 수중 경치를 즐길 수 있습니다. 발판이 바위투성이라 마린슈즈가 있으면 안심입니다.",
      },
    },
    description: "伊良部島側の海を望む岩場のスポットで、透明度の高い水中を楽しめます。足場が岩がちなため、マリンシューズがあると安心です。",
    image: img("v1788400653/DSC00238_cpopda.jpg", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.5m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "岩場のため上級者向け",
    snorkel: 5,
    sup: 1,
    dronePhoto: 4,
    underwaterPhoto: 5,
    facing: 0,
    categories: ["snorkel"],
    crowdLevel: "crowdQuiet",
    mapQuery: "サバウツガー 宮古島",
  },
  {
    name: "中の島海岸",
    reading: "",
    i18n: {
      EN: {
        name: "Nakanoshima Coast",
        description: "Located on Shimoji Island, this snorkeling spot is popular around Miyakojima for its abundant fish and high clarity. There are tidal currents, so it's best enjoyed while checking the tide level and time of day.",
      },
      中文: {
        description: "位于下地岛，鱼群密集、透明度也高，是宫古岛周边人气很高的浮潜景点。因有潮流，建议确认潮位和时段后再前往游玩。",
      },
      한국어: {
        name: "나카노시마 해안",
        description: "시모지섬에 있으며 물고기가 많고 투명도도 높아 미야코지마 주변에서도 인기 있는 스노클링 스팟입니다. 조류가 있으므로 조수 수위와 시간대를 확인하고 즐기는 것을 추천합니다.",
      },
    },
    description: "下地島にあり、魚影が濃く透明度も高いことで宮古島周辺でも人気のシュノーケルスポット。潮の流れがあるため、潮位と時間帯を確認して楽しむのがおすすめです。",
    image: img("v1788401955/%E4%B8%AD%E4%B9%8B%E5%B3%B6_t6pa7k.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "南東 3m/s",
    clarity: "高い",
    beginner: "潮位に注意",
    snorkel: 5,
    sup: 1,
    dronePhoto: 1,
    photo: 1,
    facing: 270,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdBusy",
    crowdScore: 5,
    mapQuery: "中の島海岸 宮古島",
    beginnerScore: 4,
    turtleScore: 0,
    parking: "なし",
    facilities: "トイレ：なし　シャワー：なし",
  },
  {
    name: "吉野海岸",
    reading: "よしのかいがん",
    i18n: {
      EN: {
        name: "Yoshino Coast",
        description: "A snorkeling spot on Miyakojima's east coast, near Higashi-Henna Cape. Coral reefs spread out right from the roughly 500m white sand beach, where you can observe colorful tropical fish such as clownfish. Just a few meters' swim from shore reveals beautiful coral and schools of fish. Thanks to the offshore reef, the inside area rarely gets rough, making it safe — but please be careful not to go out too far.",
      },
      中文: {
        description: "位于宫古岛东海岸，靠近东平安名崎的浮潜景点。从约500米长的白色沙滩起就是珊瑚礁，可观察小丑鱼等色彩缤纷的热带鱼。从岸边只需游几米就能看到美丽的珊瑚礁和鱼群。得益于外侧的礁石，内侧海浪不易掀起，比较安全，但请注意不要游到外海。",
      },
      한국어: {
        name: "요시노 해안",
        description: "미야코지마 동해안, 히가시헨나자키 근처에 있는 스노클링 스팟. 약 500m의 하얀 모래사장에서 바로 산호초가 펼쳐지며 흰동가리 등 형형색색의 열대어를 관찰할 수 있습니다. 해안에서 몇 미터만 헤엄쳐도 아름다운 산호초와 물고기 떼를 볼 수 있습니다. 앞바다의 리프 덕분에 안쪽은 파도가 잘 일지 않아 안전하지만, 먼바다까지 나가지 않도록 주의하세요.",
      },
    },
    description: "宮古島の東海岸、東平安名崎近くにあるシュノーケルスポット。約500mの白い砂浜からすぐにサンゴ礁が広がり、クマノミなど色とりどりの熱帯魚を観察できます。岸から数メートル泳ぐだけで、美しいサンゴ礁と魚の群れが見られます。沖のリーフのおかげで、インサイド（内側）は波が立ちにくく安全です。沖まで出ないようご注意ください。",
    image: img("v1788401954/%E5%90%89%E9%87%8E%E6%B5%B7%E5%B2%B8_yzq1f4.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "東 3m/s",
    clarity: "高い",
    beginner: "初心者にもおすすめ",
    snorkel: 5,
    sup: 2,
    dronePhoto: 2,
    underwaterPhoto: 3,
    photo: 1,
    facing: 90,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdBusy",
    crowdScore: 2,
    mapQuery: "吉野海岸 宮古島",
    beginnerScore: 5,
    turtleScore: 4,
    parking: "あり",
    facilities: "トイレ：あり　シャワー：あり",
  },
  {
    name: "イキヅービーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Ikizu Beach",
        description: "A quiet beach on the west coast of Ikema Island. Also known for Heart Rock, its pure white sand and calm sea are its charm.",
      },
      中文: {
        description: "位于池间岛西岸的宁静海滩。也以爱心岩闻名，纯白的沙滩与平稳的海面是其魅力所在。",
      },
      한국어: {
        name: "이키즈 비치",
        description: "이케마섬 서쪽 해안에 있는 조용한 해변. 하트 바위로도 알려져 있으며 새하얀 모래사장과 잔잔한 바다가 매력입니다.",
      },
    },
    description: "池間島西岸にある静かなビーチ。ハート岩でも知られ、真っ白な砂浜と穏やかな海が魅力です。",
    image: img("v1788401954/%E3%82%A4%E3%82%AD%E3%83%84%E3%82%99%E3%83%BC%E3%83%92%E3%82%99%E3%83%BC%E3%83%81_xtfhl0.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "西 3m/s",
    clarity: "高い",
    beginner: "波が穏やかで安心",
    snorkel: 3,
    sup: 2,
    // The small cove opens northwest rather than due west, so northerly and
    // northeasterly winds still reach the beach as cross/onshore wind.
    facing: 315,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdQuiet",
    mapQuery: "イキヅービーチ 池間島",
    beginnerScore: 2,
    turtleScore: 0,
    parking: "なし",
    facilities: "トイレ：なし　シャワー：なし",
  },
  {
    name: "フナクスビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Funakusu Beach",
        description: "A hidden but popular spot on the north side of Ikema Island. You can observe colorful coral and fish from the shallows, and the waves stay calm as long as the wind isn't from the north.",
      },
      中文: {
        description: "位于池间岛北侧的隐藏人气景点。从浅滩就能观察到色彩斑斓的珊瑚和鱼群，只要不是刮北风，海浪都很平稳。",
      },
      한국어: {
        name: "후나쿠스 비치",
        description: "이케마섬 북쪽에 있는 숨은 인기 스팟. 얕은 곳에서부터 형형색색의 산호와 물고기를 관찰할 수 있으며, 북풍만 아니라면 파도도 잔잔합니다.",
      },
    },
    description: "池間島の北側にある隠れた人気スポット。浅瀬から色とりどりのサンゴや魚を観察でき、北風でなければ波も穏やかです。",
    image: img("https://res.cloudinary.com/drxijtp8g/image/upload/v1789052484/DSC00348_eyt7ze.jpg", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.4m",
    wind: "北 3m/s",
    clarity: "高い",
    beginner: "北風の日は注意",
    snorkel: 5,
    sup: 1,
    photo: 3,
    dronePhoto: 3,
    facing: 45,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdModerate",
    crowdScore: 2,
    mapQuery: "フナクスビーチ 池間島",
    beginnerScore: 4,
    turtleScore: 0,
    parking: "あり",
    facilities: "トイレ：あり　シャワー：なし",
  },
  {
    name: "インギャーマリンガーデン",
    reading: "",
    i18n: {
      EN: {
        name: "Ingya Marine Garden",
        description: "Ingya Marine Garden makes use of a natural inlet, a seaside park known for its calm, emerald-green water and the stunning view from its observation deck. Because the beach forms a cove, the bay stays calm even on days with some waves outside.",
      },
      中文: {
        description: "因濑玛琳花园利用天然海湾而建，是以平稳的翡翠绿海水和展望台绝景而闻名的海滨公园。由于海滩呈海湾状，即使外海略有浪时，湾内依然平稳。",
      },
      한국어: {
        name: "인갸 마린가든",
        description: "천연 후미를 활용한 인갸 마린가든은 잔잔한 에메랄드빛 바다와 전망대에서 보는 절경이 매력인 해변 공원입니다. 해변이 후미 지형이라 바깥쪽에 파도가 다소 있는 날에도 만 안쪽은 잔잔합니다.",
      },
    },
    description: "天然の入り江を利用したインギャーマリンガーデンは、波が穏やかなエメラルドグリーンの海と、展望台からの絶景が魅力の海浜公園。ビーチは入江になっているため、多少波がある日などでも湾内は穏やかです。",
    image: img("v1788400057/DSC00111_ycednh.jpg", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.3m",
    wind: "南 2m/s",
    clarity: "高い",
    beginner: "安心",
    snorkel: 3,
    sup: 1,
    dronePhoto: 5,
    underwaterPhoto: 1,
    milkyWay: 3,
    facing: 180,
    sheltered: true,
    categories: ["snorkel", "beach"],
    crowdLevel: "crowdBusy",
    crowdScore: 4,
    mapQuery: "インギャーマリンガーデン 宮古島",
    beginnerScore: 5,
    turtleScore: 0,
    parking: "あり",
    facilities: "トイレ：あり　シャワー：あり",
  },
  {
    name: "東平安名崎",
    reading: "",
    i18n: {
      EN: {
        name: "Higashi-Henna Cape",
        description: "A cape jutting out from Miyakojima's eastern tip, offering a sweeping view of both the East China Sea and the Pacific Ocean. With no tall buildings nearby, it offers especially beautiful scenery when conditions are right for stargazing or sunrise.",
      },
      中文: {
        description: "从宫古岛东端突出的海角，可将东海与太平洋尽收眼底的绝景景点。周围没有高层建筑，天气和星空、日出条件合适时景色格外美丽。",
      },
      한국어: {
        name: "히가시헨나자키",
        description: "미야코지마 동쪽 끝에서 돌출된 곶으로 동중국해와 태평양을 한눈에 볼 수 있는 절경 스팟입니다. 주변에 높은 건물이 없어 별하늘이나 일출 조건이 맞는 날에는 특히 아름다운 풍경이 펼쳐집니다.",
      },
    },
    description: "宮古島東端に突き出た岬で、東シナ海と太平洋を一望できる絶景スポット。周囲に高い建物がなく、星空や朝日の条件が合う日は特に美しい景色が広がります。",
    image: "https://res.cloudinary.com/drxijtp8g/image/upload/v1788962817/DJI_20260705182242_0015_D_xmivyn.webp",
    status: "good",
    wave: "0.6m",
    wind: "東南東 4m/s",
    clarity: "高い",
    beginner: "風に注意",
    snorkel: 2,
    sup: 2,
    photo: 5,
    milkyWay: 5,
    starBestTime: "21:00〜深夜",
    facing: 90,
    darkness: 5,
    driveMinutes: 35,
    categories: ["stars"],
    mapQuery: "東平安名崎 宮古島",
  },
  {
    name: "渡口の浜",
    reading: "とぐちのはま",
    i18n: {
      EN: {
        name: "Toguchi Beach",
        description: "A quiet beach on the south side of Irabu Island. Known for its pure white sand and shallow water, with little light pollution making it good for stargazing too.",
      },
      中文: {
        description: "位于伊良部岛南侧的宁静海滩。以纯白沙滩和远浅海水为特征，灯光稀少，也适合观星。",
      },
      한국어: {
        name: "도구치하마",
        description: "이라부섬 남쪽에 펼쳐진 조용한 해변. 새하얀 모래사장과 완만한 바다가 특징이며 불빛이 적어 별하늘 관측에도 좋습니다.",
      },
    },
    description: "伊良部島の南側に広がる静かなビーチ。真っ白な砂浜と遠浅の海が特徴で、街灯りが少なく星空観察にも向いています。",
    image: img("v1788965841/渡口_lybwqu.png", {
      width: 900,
      height: 520,
    }),
    youtubeId: "C5q5NOUerqA",
    photo: 4,
    milkyWay: 4,
    sunsetScore: 2,
    facing: 180,
    darkness: 4,
    driveMinutes: 20,
    beginnerScore: 5,
    categories: ["stars", "beach"],
    mapQuery: "渡口の浜 伊良部島",
  },
  {
    name: "比嘉ロードパーク",
    reading: "",
    i18n: {
      EN: {
        name: "Higa Road Park",
        description: "A lookout spot along the prefectural road where you can view the East China Sea from a cliff edge. You can see as far as Ikema Island and Higashi-Henna Cape, and it's also known as a spot for sunrise, sunset, and stargazing.",
      },
      中文: {
        description: "位于县道旁悬崖上的展望景点，可以将东海尽收眼底。可远眺池间岛和东平安名崎方向，也以朝阳、夕阳和星空的名胜而闻名。",
      },
      한국어: {
        name: "히가 로드파크",
        description: "현도를 따라 절벽 위에서 동중국해를 한눈에 볼 수 있는 전망 스팟. 이케마섬이나 히가시헨나자키 방면까지 내다보이며 일출・일몰・별하늘 명소로도 알려져 있습니다.",
      },
    },
    description: "県道沿いの断崖絶壁から東シナ海を一望できる展望スポット。池間島や東平安名崎方面まで見渡せ、朝日・夕日・星空の名所としても知られています。",
    image: img("v1788968415/ひがロードパーク_bsqyfa.png", {
      width: 900,
      height: 520,
    }),
    photo: 5,
    milkyWay: 4,
    facing: 270,
    darkness: 5,
    driveMinutes: 25,
    categories: ["stars"],
    mapQuery: "比嘉ロードパーク 宮古島",
  },
  {
    name: "白鳥岬",
    reading: "しらとりみさき",
    i18n: {
      EN: {
        name: "Shiratori Cape",
        description: "The northernmost cape of Irabu Island. The reef is close to the beach, so you can enjoy snorkeling too, and with an unobstructed horizon and few people around, it's also a hidden gem for leisurely stargazing.",
      },
      中文: {
        description: "伊良部岛最北端的海角。从海滩到礁石的距离很近，也可以享受浮潜，且视野开阔无遮挡、人烟稀少，是可以悠闲观星的私藏景点。",
      },
      한국어: {
        name: "시라토리미사키",
        description: "이라부섬 최북단의 곶. 해변에서 리프까지 가까워 스노클링도 즐길 수 있으며, 가리는 것 없는 수평선과 인적이 드문 조용한 환경 덕분에 별하늘도 여유롭게 즐길 수 있는 숨은 명소입니다.",
      },
    },
    description: "伊良部島最北端の岬。浜からリーフまでが近くシュノーケルも楽しめるほか、遮るもののない水平線と人が少ない静かな環境で星空もゆっくり楽しめる穴場スポットです。",
    image: img("v1788401955/%E7%99%BD%E9%B3%A5%E5%B2%AC_ftrl2u.png", {
      width: 900,
      height: 520,
    }),
    status: "good",
    wave: "0.6m",
    wind: "北 4m/s",
    clarity: "高い",
    beginner: "岩場のため上級者向け",
    snorkel: 5,
    sup: 1,
    dronePhoto: 3,
    underwaterPhoto: 5,
    photo: 5,
    milkyWay: 5,
    facing: 0,
    darkness: 5,
    driveMinutes: 30,
    categories: ["stars", "snorkel"],
    crowdLevel: "crowdQuiet",
    mapQuery: "白鳥岬 伊良部島",
    beginnerScore: 0,
    turtleScore: 1,
    parking: "あり",
    facilities: "トイレ：あり　シャワー：なし",
  },
  {
    name: "通り池",
    reading: "とおりいけ",
    i18n: {
      EN: {
        name: "Tori-ike (Twin Ponds)",
        description: "Two circular ponds on Shimoji Island, designated a national scenic spot and natural monument. Their mysterious landscape, connected underground to the sea, sits in an area with little artificial light, making it great for stargazing too.",
      },
      中文: {
        description: "位于下地岛，被指定为国家名胜・天然纪念物的两个圆形池塘。地下与海相连的神秘景观，周边人工照明稀少，也很适合观星。",
      },
      한국어: {
        name: "도리이케",
        description: "시모지섬에 있는 국가 지정 명승・천연기념물인 두 개의 원형 연못. 지하와 바다가 이어진 신비로운 경관으로, 주변에 인공 불빛이 적어 별하늘 관측에도 좋습니다.",
      },
    },
    description: "下地島にある国指定名勝・天然記念物の二つの円形の池。地下と海がつながる神秘的な景観で、周辺は人工の灯りが少なく星空にもおすすめです。",
    image: img("v1788968023/通りいけ_oakwz8.png", {
      width: 900,
      height: 520,
    }),
    photo: 5,
    milkyWay: 4,
    facing: 270,
    darkness: 5,
    driveMinutes: 30,
    categories: ["stars"],
    mapQuery: "通り池 下地島",
  },
  {
    name: "パチャビーチ",
    reading: "",
    i18n: {
      EN: {
        name: "Pacha Beach",
        description: "A beach at the foot of Kurima Bridge, on the Kurima Island side. Along with shallow, clear water, it's close to a beach house and BBQ facilities, making it a popular and easy-to-visit spot.",
      },
      中文: {
        description: "位于来间大桥桥墩、来间岛一侧的海滩。除了远浅且透明度高的海水外，还靠近海滩小屋和烧烤设施，是可以轻松前往的人气景点。",
      },
      한국어: {
        name: "파차 비치",
        description: "구리마대교 아래, 구리마섬 쪽에 펼쳐진 해변. 완만하고 투명도 높은 바다에 더해 비치하우스와 바비큐 시설도 가까워 부담 없이 들를 수 있는 인기 스팟입니다.",
      },
    },
    description: "来間大橋のたもと、来間島側に広がるビーチ。遠浅で透明度の高い海に加え、ビーチハウスやBBQ施設も近く、気軽に立ち寄れる人気スポットです。",
    image: "https://res.cloudinary.com/drxijtp8g/image/upload/v1788962796/DJI_20260830153031_0059_D_nag7aa.webp",
    photo: 4,
    milkyWay: 5,
    facing: 45,
    // North/northeast wind has to cross Miyako-jima's main island before reaching
    // this east-facing Kurima-jima beach across the narrow strait, plus the fishing
    // port/breakwater next door adds local shelter — noticeably calmer than a
    // straight facing-angle read would suggest, even though it isn't a fully
    // enclosed bay.
    sheltered: true,
    darkness: 3,
    driveMinutes: 20,
    crowdScore: 1,
    categories: ["stars", "beach"],
    mapQuery: "パチャビーチ 来間島",
  },
  {
    name: "博愛漁港",
    reading: "",
    i18n: {
      EN: {
        name: "Hakuai Fishing Port",
        description: "A quiet fishing port on the south side of Miyakojima. Watch local fishing boats while enjoying the nighttime sea in a calm atmosphere.",
      },
      中文: {
        description: "位于宫古岛南侧的宁静渔港。可以一边眺望当地渔船，一边在悠闲的氛围中享受夜晚的海景。",
      },
      한국어: {
        name: "하쿠아이 어항",
        description: "미야코지마 남쪽에 있는 조용한 어항. 지역 어선을 바라보며 차분한 분위기 속에서 밤바다를 즐길 수 있는 스팟입니다.",
      },
    },
    description: "宮古島南側にある静かな漁港。地元の漁船を眺めながら、落ち着いた雰囲気で夜の海を楽しめるスポットです。",
    image: img("v1785005393/DSC00191_small_lhfvnk.jpg", {
      width: 900,
      height: 520,
    }),
    photo: 3,
    milkyWay: 3,
    facing: 180,
    darkness: 3,
    driveMinutes: 15,
    categories: ["stars"],
    mapQuery: "博愛漁港 宮古島",
  },
  {
    name: "赤浜漁港",
    reading: "",
    i18n: {
      EN: {
        name: "Akahama Fishing Port",
        description: "A fishing port along the coast in central Miyakojima. You can watch the sunset from the breakwater, and with little light nearby, it's also recommended for those who want to enjoy stars and night views.",
      },
      中文: {
        description: "位于宫古岛中部海边的渔港。可以从堤防眺望夕阳，周边灯光稀少，也推荐给想欣赏星空和夜景的人。",
      },
      한국어: {
        name: "아카하마 어항",
        description: "미야코지마 중앙부 해안에 있는 어항. 방파제에서 석양을 볼 수 있고 주변에 불빛이 적어 별하늘이나 야경을 즐기고 싶은 사람에게도 추천합니다.",
      },
    },
    description: "宮古島中央部の海沿いにある漁港。堤防から夕日を眺められるほか、周辺に明かりが少なく星空や夜景を楽しみたい人にもおすすめです。",
    image: img("v1788967380/スクリーンショット_2026-09-10_0.22.40_hyh3nb.png", {
      width: 900,
      height: 520,
    }),
    photo: 4,
    milkyWay: 5,
    sunsetScore: 3,
    crowdLevel: "crowdQuiet",
    facing: 270,
    darkness: 5,
    driveMinutes: 10,
    categories: ["stars", "sunset"],
    mapQuery: "赤浜漁港 宮古島",
  },
  {
    name: "帯岩",
    reading: "おびいわ",
    i18n: {
      EN: {
        name: "Obi Rock",
        description: "A massive single rock on Shimoji Island, about 12m high and 60m around. Said to have been washed ashore by a tsunami, it's one of Miyakojima's iconic natural formations.",
      },
      中文: {
        description: "位于下地岛，高约12米、周长约60米的巨大整体岩石。相传是被海啸冲上岸的，是宫古岛代表性的自然景观。",
      },
      한국어: {
        name: "오비이와",
        description: "시모지섬에 있는 높이 약 12m, 둘레 약 60m의 거대한 하나의 바위. 쓰나미에 의해 밀려왔다고 전해지는, 미야코지마를 대표하는 자연 조형물입니다.",
      },
    },
    description: "下地島にある高さ約12m、周囲約60mの巨大な一枚岩。津波によって打ち上げられたと伝わる、宮古島を代表する自然の造形です。",
    image: img("v1788967419/帯岩_dmjle1.png", {
      width: 900,
      height: 520,
    }),
    photo: 4,
    milkyWay: 4,
    facing: 270,
    darkness: 4,
    driveMinutes: 40,
    categories: ["stars"],
    mapQuery: "帯岩 下地島",
  },
  {
    name: "高野漁港",
    reading: "",
    i18n: {
      EN: {
        name: "Takano Fishing Port",
        description: "A small fishing port in southern Miyakojima. With little light around, it's a hidden gem for those who want to enjoy stargazing quietly.",
      },
      中文: {
        description: "位于宫古岛南部的小渔港。周边灯光稀少，是想安静观星的人的私藏景点。",
      },
      한국어: {
        name: "다카노 어항",
        description: "미야코지마 남부에 있는 작은 어항. 주변에 불빛이 적어 조용히 별하늘을 즐기고 싶은 사람에게 추천하는 숨은 명소입니다.",
      },
    },
    description: "宮古島南部にある小さな漁港。周辺に明かりが少なく、静かに星空観察を楽しみたい人向けの穴場スポットです。",
    image: img("v1785005393/DSC00191_small_lhfvnk.jpg", {
      width: 900,
      height: 520,
    }),
    photo: 4,
    milkyWay: 4,
    facing: 180,
    darkness: 5,
    driveMinutes: 15,
    categories: ["stars"],
    mapQuery: "高野漁港 宮古島",
  },
  {
    name: "シークレットポイント",
    reading: "",
    i18n: {
      EN: {
        name: "Secret Point",
        description: "Miyakojima has multiple secret points that even locals don't know about. Book a stargazing tour to visit a special spot.",
        driveTimeText: "Varies by point",
      },
      中文: {
        description: "宫古岛存在多个连当地人都不知道的秘密景点。请预约星空之旅前往特别地点。",
        driveTimeText: "因地点而异",
      },
      한국어: {
        name: "시크릿 포인트",
        description: "미야코지마에는 현지인도 모르는 시크릿 포인트가 여러 곳 있습니다. 별하늘 투어를 예약하고 특별한 스팟으로 떠나보세요.",
        driveTimeText: "포인트마다 다름",
      },
    },
    description: "宮古島には住んでる人も知らないシークレットポイントが複数存在します。星空ツアーを予約して特別なスポットへ",
    image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp", {
      width: 900,
      height: 520,
    }),
    photo: 5,
    milkyWay: 5,
    facing: 180,
    darkness: 5,
    driveTimeText: "ポイントにより異なる",
    categories: ["stars"],
    mapQuery: "宮古島 シークレットポイント",
  },
  {
    name: "西平安名崎",
    reading: "にしへんなざき",
    i18n: {
      EN: {
        name: "Nishi-Henna Cape",
        description: "A cape at Miyakojima's northwestern tip, just before Ikema Bridge. A hidden gem where you can enjoy the sight of wind turbines lined up together with the sun setting into the sea.",
      },
      中文: {
        description: "位于宫古岛西北端，池间大桥前的海角。可以同时欣赏排列的风力发电风车与沉入海中的夕阳，是私藏绝景点。",
      },
      한국어: {
        name: "니시헨나자키",
        description: "미야코지마 북서쪽 끝, 이케마대교 직전에 있는 곶. 늘어선 풍력 발전 풍차와 바다로 지는 석양을 함께 즐길 수 있는 숨은 절경 스팟입니다.",
      },
    },
    description: "宮古島北西端、池間大橋の手前にある岬。風力発電の風車が並ぶ景色と、海に沈む夕日を一緒に楽しめる隠れた絶景スポットです。",
    image: img("v1788997944/西変なざき_nkwwsi.png", {
      width: 900,
      height: 520,
    }),
    photo: 5,
    sunsetScore: 5,
    crowdLevel: "crowdQuiet",
    categories: ["sunset"],
    mapQuery: "西平安名崎 宮古島",
  },
  {
    name: "川満漁港",
    reading: "かわみつぎょこう",
    i18n: {
      EN: {
        name: "Kawamitsu Fishing Port",
        description: "A fishing port in southern Miyakojima. A hidden gem popular with locals, where you can watch the sunset over the breakwater.",
      },
      中文: {
        description: "位于宫古岛南部的渔港。可以隔着堤防眺望夕阳，是深受当地人喜爱的私藏景点。",
      },
      한국어: {
        name: "가와미츠 어항",
        description: "미야코지마 남부에 있는 어항. 방파제 너머로 석양을 볼 수 있는, 현지인에게도 인기 있는 숨은 명소입니다.",
      },
    },
    description: "宮古島南部にある漁港。堤防越しに夕日を眺められる、地元の人にも人気の穴場スポットです。",
    image: img("v1785005393/DSC00191_small_lhfvnk.jpg", {
      width: 900,
      height: 520,
    }),
    photo: 3,
    sunsetScore: 4,
    crowdLevel: "crowdQuiet",
    categories: ["sunset"],
    mapQuery: "川満漁港 宮古島",
  },
  {
    name: "シークレットスポット",
    reading: "",
    i18n: {
      EN: {
        name: "Secret Spot",
        description: "Miyakojima has the ultimate sunset spot. While doing SUP, you can watch the sunset drop right in front of you from out on the water. Join a sunset SUP tour.",
      },
      中文: {
        description: "宫古岛存在终极日落景点。乘坐SUP，可以从海上近距离看着夕阳在眼前落下。请参加日落SUP行程。",
      },
      한국어: {
        name: "시크릿 스팟",
        description: "미야코지마에는 궁극의 선셋 스팟이 있습니다. SUP를 타면서 눈앞으로 떨어지는 노을을 바다 위에서 볼 수 있습니다. 선셋 SUP 투어에 참여해 보세요.",
      },
    },
    description: "宮古島には究極のサンセットスポットが存在します。SUPをしながら目の前に落ちていくサンセットを海の上から見れる。サンセットSUPのツアーにご参加ください。",
    image: "https://res.cloudinary.com/drxijtp8g/image/upload/v1785311449/DSC00588-2_x2m1d1.webp",
    photo: 4,
    sunsetScore: 5,
    crowdLevel: "crowdPrivate",
    categories: ["sunset"],
    mapQuery: "池間大橋 駐車場 宮古島",
  },
];

export const baseMapSpots = [
  {
    name: "新城海岸",
    facing: 0,
    categories: ["snorkel", "beach"],
    location: { lat: 24.7599, lng: 125.4249 },
  },
  {
    name: "吉野海岸",
    facing: 90,
    categories: ["snorkel", "beach"],
    location: { lat: 24.7481, lng: 125.4423 },
  },
  {
    name: "ワイワイビーチ",
    facing: 180,
    categories: ["snorkel", "stars", "beach"],
    location: { lat: 24.7194, lng: 125.3301 },
  },
  {
    name: "シギラビーチ",
    facing: 180,
    categories: ["snorkel", "beach"],
    location: { lat: 24.7202654, lng: 125.3408467 },
  },
  {
    name: "サバウツガー",
    facing: 0,
    categories: ["snorkel"],
    location: { lat: 24.8470632, lng: 125.205828 },
  },
  {
    name: "中の島海岸",
    facing: 270,
    categories: ["snorkel", "beach"],
    location: { lat: 24.813391, lng: 125.145466 },
  },
  {
    name: "東平安名崎",
    categories: ["stars"],
    location: { lat: 24.7195, lng: 125.4684 },
  },
  {
    name: "長間浜",
    facing: 270,
    categories: ["sunset", "beach"],
    location: { lat: 24.7250662, lng: 125.2396462 },
  },
  {
    name: "サンセットビーチ",
    facing: 270,
    categories: ["sunset", "beach"],
    location: { lat: 24.799, lng: 125.258 },
  },
  {
    name: "与那覇前浜ビーチ",
    facing: 270,
    categories: ["sunset", "stars", "beach"],
    location: { lat: 24.735, lng: 125.265 },
  },
  {
    name: "砂山ビーチ",
    facing: 0,
    categories: ["sunset", "snorkel", "beach"],
    location: { lat: 24.8395634, lng: 125.2806924 },
  },
  {
    name: "フナクスビーチ",
    facing: 45,
    categories: ["snorkel", "beach"],
    location: { lat: 24.9375, lng: 125.2453 },
  },
  {
    name: "イキヅービーチ",
    facing: 315,
    categories: ["snorkel", "beach"],
    location: { lat: 24.9319, lng: 125.2333 },
  },
  {
    name: "インギャーマリンガーデン",
    facing: 180,
    sheltered: true,
    categories: ["snorkel", "stars", "beach"],
    location: { lat: 24.7247, lng: 125.3584 },
  },
  {
    name: "伊良部大橋",
    facing: 0,
    sheltered: true,
    categories: ["sunset"],
    location: { lat: 24.8178419, lng: 125.2182529 },
  },
  {
    name: "17END",
    facing: 270,
    categories: ["sunset", "beach"],
    location: { lat: 24.8421325, lng: 125.1398185 },
  },
  {
    name: "ムスヌン浜",
    facing: 270,
    categories: ["sunset", "stars", "beach"],
    location: { lat: 24.7179032, lng: 125.2400523 },
  },
  {
    name: "渡口の浜",
    facing: 180,
    categories: ["stars", "beach"],
    location: { lat: 24.8117373, lng: 125.1806646 },
  },
  {
    name: "比嘉ロードパーク",
    categories: ["stars"],
    location: { lat: 24.7849365, lng: 125.3843373 },
  },
  {
    name: "白鳥岬",
    facing: 0,
    categories: ["stars", "snorkel"],
    location: { lat: 24.8631199, lng: 125.1629139 },
  },
  {
    name: "通り池",
    categories: ["stars"],
    location: { lat: 24.8236648, lng: 125.1361496 },
  },
  {
    name: "パチャビーチ",
    facing: 45,
    sheltered: true,
    categories: ["stars", "beach"],
    location: { lat: 24.7240936, lng: 125.2551148 },
  },
  {
    name: "博愛漁港",
    categories: ["stars"],
    location: { lat: 24.7195255, lng: 125.3286997 },
  },
  {
    name: "赤浜漁港",
    facing: 270,
    sheltered: true,
    categories: ["stars", "sunset"],
    location: { lat: 24.7879442, lng: 125.257087 },
  },
  {
    name: "帯岩",
    categories: ["stars"],
    location: { lat: 24.8189215, lng: 125.1407334 },
  },
  {
    name: "高野漁港",
    categories: ["stars"],
    location: { lat: 24.8017615, lng: 125.3322568 },
  },
  {
    // Decoy pin position — real location intentionally not disclosed on the map.
    name: "シークレットポイント",
    categories: ["stars"],
    location: { lat: 24.91, lng: 125.145 },
  },
  {
    name: "西平安名崎",
    facing: 270,
    categories: ["sunset"],
    location: { lat: 24.9093678, lng: 125.2568654 },
  },
  {
    name: "川満漁港",
    facing: 180,
    sheltered: true,
    categories: ["sunset"],
    location: { lat: 24.7619091, lng: 125.2823993 },
  },
  {
    // Decoy pin position — real location intentionally not disclosed on the map.
    name: "シークレットスポット",
    facing: 270,
    categories: ["sunset"],
    location: { lat: 24.9, lng: 125.16 },
  },
  {
    name: "Blue Turtle",
    i18n: {
      EN: {
        genre: "Lunch / Cafe",
        detail: "A popular cafe near Toguchi Beach where you can feel the ocean nearby. Great for lunch or a break during a drive around Irabu Island.",
        menuFood: "Cafe meals / Sweets",
        menuDrink: "Smoothies / Cafe drinks",
      },
      中文: {
        genre: "午餐/咖啡厅",
        detail: "位于渡口海滩附近，可以感受大海气息的人气咖啡厅。适合在伊良部岛兜风途中用午餐或休息。",
        menuFood: "咖啡简餐/甜点",
        menuDrink: "冰沙/咖啡饮品",
      },
      한국어: {
        genre: "런치/카페",
        detail: "도구치하마 근처에서 바다를 느끼며 시간을 보낼 수 있는 인기 카페. 이라부섬 드라이브 중 점심이나 휴식에 추천합니다.",
        menuFood: "카페 식사/디저트",
        menuDrink: "스무디/카페 음료",
      },
    },
    type: "food",
    kind: "food",
    status: "海カフェ",
    genre: "ランチ / カフェ",
    area: "伊良部島",
    detail: "渡口の浜近くで海を感じながら過ごせる人気カフェ。伊良部島ドライブ中のランチや休憩におすすめです。",
    crowd: "やや混雑",
    crowdScore: 3,
    parking: "あり",
    menu: {
      food: "カフェごはん / スイーツ",
      drink: "スムージー / カフェドリンク",
    },
    instaPostUrl: "https://www.instagram.com/p/DTZdliiE1Xt/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 5,
    hours: "11:00〜21:00",
    closed: "不定休",
    categories: ["cafe", "lunch"],
    location: { lat: 24.8291, lng: 125.172 },
  },
  {
    name: "OHAMAテラス",
    i18n: {
      EN: {
        name: "OHAMA Terrace",
        genre: "Lunch / Cafe",
        detail: "A terrace cafe with a panoramic view of Ikema Island's sea. Perfect for photos on a sunny day or a break during your drive.",
        menuFood: "Taco rice / Light meals",
        menuDrink: "Tropical drinks / Mango-based drinks",
      },
      中文: {
        genre: "午餐/咖啡厅",
        detail: "可将池间岛的大海尽收眼底的露台咖啡厅。非常适合晴天拍照或兜风休息。",
        menuFood: "塔可饭/轻食",
        menuDrink: "热带饮品/芒果系饮品",
      },
      한국어: {
        name: "오하마 테라스",
        genre: "런치/카페",
        detail: "이케마섬의 바다를 한눈에 볼 수 있는 테라스 카페. 맑은 날 사진 촬영이나 드라이브 휴식에 딱입니다.",
        menuFood: "타코라이스/가벼운 식사",
        menuDrink: "트로피컬 드링크/망고 계열 음료",
      },
    },
    type: "food",
    kind: "food",
    status: "海カフェ",
    genre: "ランチ / カフェ",
    area: "池間島",
    detail: "池間島の海を一望できるテラスカフェ。晴れた日の写真やドライブ休憩にぴったりです。",
    crowd: "比較的入りやすい",
    parking: "あり",
    menu: {
      food: "タコライス / 軽食",
      drink: "トロピカルドリンク / マンゴー系ドリンク",
    },
    instaPostUrl: "https://www.instagram.com/p/CGgJO1zgvUz/?igsh=anc5YXQybXExZHd1",
    baeScore: 5,
    hours: "10:00〜16:30",
    closed: "木曜日",
    categories: ["cafe", "lunch"],
    location: { lat: 24.9373, lng: 125.2493 },
  },
  {
    name: "HARRY'S Shrimp Truck",
    i18n: {
      EN: {
        genre: "Shrimp / Takeout",
        detail: "An easy stop for shrimp-based lunch during your ocean drive. Recommended for a casual meal.",
        menuFood: "Garlic shrimp / Lunch plate",
        menuDrink: "Soft drinks",
      },
      中文: {
        genre: "虾料理/外带",
        detail: "海边兜风途中方便顺路品尝的虾料理午餐。适合想轻松用餐的日子。",
        menuFood: "蒜香虾/午餐拼盘",
        menuDrink: "软饮料",
      },
      한국어: {
        genre: "쉬림프/테이크아웃",
        detail: "바다 드라이브 중에 들르기 좋은 쉬림프 런치. 캐주얼하게 먹고 싶은 날 추천합니다.",
        menuFood: "갈릭 쉬림프/런치 플레이트",
        menuDrink: "소프트드링크",
      },
    },
    type: "food",
    kind: "food",
    status: "ランチ",
    genre: "シュリンプ / テイクアウト",
    area: "平良",
    detail: "海ドライブの途中に寄りやすいシュリンプ系ランチ。カジュアルに食べたい日におすすめです。",
    crowd: "混雑しやすい",
    parking: "あり",
    menu: {
      food: "ガーリックシュリンプ / ランチプレート",
      drink: "ソフトドリンク",
    },
    hours: "要確認",
    closed: "要確認",
    categories: ["cafe", "lunch"],
    location: { lat: 24.7838, lng: 125.2828 },
  },
  {
    name: "Pani Pani",
    i18n: {
      EN: {
        genre: "Tropical Cafe",
        detail: "A cafe with the tropical feel unique to Kurima Island. Recommended for a relaxed day or when you want to take photos.",
        menuFood: "Tropical cafe menu / Sweets",
        menuDrink: "Tropical drinks",
      },
      中文: {
        genre: "南国风咖啡厅",
        detail: "可以享受来间岛特有南国氛围的咖啡厅。适合想悠闲度过或拍照的日子。",
        menuFood: "南国咖啡菜单/甜点",
        menuDrink: "热带饮品",
      },
      한국어: {
        genre: "남국 카페",
        detail: "구리마섬다운 남국 분위기를 즐길 수 있는 카페. 여유롭게 보내고 싶은 날이나 사진을 찍고 싶은 날 추천합니다.",
        menuFood: "남국 카페 메뉴/디저트",
        menuDrink: "트로피컬 드링크",
      },
    },
    type: "food",
    kind: "food",
    status: "カフェ",
    genre: "南国カフェ",
    area: "来間島",
    detail: "来間島らしい南国感を楽しめるカフェ。ゆっくり過ごしたい日や写真を撮りたい日におすすめです。",
    crowd: "混雑しやすい",
    parking: "あり",
    menu: {
      food: "南国カフェメニュー / スイーツ",
      drink: "トロピカルドリンク",
    },
    instaPostUrl: "https://www.instagram.com/reel/CwP45f7KSse/?utm_source=ig_web_copy_link",
    baeScore: 5,
    hours: "要確認",
    closed: "要確認",
    categories: ["cafe", "lunch"],
    location: { lat: 24.7194, lng: 125.2481 },
  },
  {
    name: "ブルータートルファーム マンゴーカフェ",
    i18n: {
      EN: {
        name: "Blue Turtle Farm Mango Cafe",
        genre: "Mango / Cafe",
        detail: "A cafe where you can enjoy mango sweets. Easy to stop by on a rainy day or between travels.",
        menuFood: "Mango sweets",
        menuDrink: "Mango drinks / Cafe drinks",
      },
      中文: {
        genre: "芒果/咖啡厅",
        detail: "可以享用芒果甜点的咖啡厅。雨天或移动途中也方便顺路前往。",
        menuFood: "芒果甜点",
        menuDrink: "芒果饮品/咖啡饮品",
      },
      한국어: {
        name: "블루터틀팜 망고카페",
        genre: "망고/카페",
        detail: "망고 디저트를 즐길 수 있는 카페. 비 오는 날이나 이동 중간에도 들르기 좋은 스팟입니다.",
        menuFood: "망고 디저트",
        menuDrink: "망고 음료/카페 음료",
      },
    },
    type: "food",
    kind: "food",
    status: "スイーツ",
    genre: "マンゴー / カフェ",
    area: "平良",
    detail: "マンゴースイーツを楽しめるカフェ。雨の日や移動の合間にも立ち寄りやすいスポットです。",
    crowd: "比較的入りやすい",
    parking: "あり",
    menu: {
      food: "マンゴースイーツ",
      drink: "マンゴードリンク / カフェドリンク",
    },
    instaPostUrl: "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 5,
    hours: "10:00〜17:30",
    closed: "なし",
    categories: ["cafe", "lunch"],
    location: { lat: 24.7774, lng: 125.2929 },
  },
  {
    name: "島cafeとぅんからや",
    i18n: {
      EN: {
        name: "Shima Cafe Tounkaraya",
        genre: "Island Cafe / Lunch",
        detail: "An island cafe easy to visit during a southern drive. Relax while feeling the sea and greenery.",
        menuFood: "Island meals / Cafe lunch",
        menuDrink: "Cafe drinks",
      },
      中文: {
        genre: "岛咖啡厅/午餐",
        detail: "南部兜风途中方便顺路的岛咖啡厅。可以一边感受大海与绿意一边悠闲度过。",
        menuFood: "岛料理/咖啡午餐",
        menuDrink: "咖啡饮品",
      },
      한국어: {
        name: "시마카페 툰카라야",
        genre: "섬 카페/런치",
        detail: "남쪽 드라이브 중 들르기 좋은 섬 카페. 바다와 초록을 느끼며 여유롭게 시간을 보낼 수 있습니다.",
        menuFood: "섬 음식/카페 런치",
        menuDrink: "카페 음료",
      },
    },
    type: "food",
    kind: "food",
    status: "海カフェ",
    genre: "島カフェ / ランチ",
    area: "上野",
    detail: "南側ドライブで寄りやすい島カフェ。海と緑を感じながらゆっくり過ごせます。",
    crowd: "比較的入りやすい",
    parking: "あり",
    menu: {
      food: "島ごはん / カフェランチ",
      drink: "カフェドリンク",
    },
    instaPostUrl: "https://www.instagram.com/sima_cafe_tounkaraya/",
    baeScore: 4,
    hours: "要確認",
    closed: "要確認",
    categories: ["cafe", "lunch"],
    location: { lat: 24.7238, lng: 125.358 },
  },
  {
    name: "Seahorse Club Cafe",
    i18n: {
      EN: {
        genre: "Resort / Pool",
        detail: "A cafe with a pool and tropical backdrop, great for photos. Also recommended for a girls' trip.",
        menuFood: "Lunch plate / Sweets",
        menuDrink: "Tropical drinks / Cafe drinks",
      },
      中文: {
        genre: "度假村/泳池",
        detail: "拥有泳池和南国氛围背景、方便拍照的咖啡厅。也很适合闺蜜旅行。",
        menuFood: "午餐拼盘/甜点",
        menuDrink: "南国饮品/咖啡饮品",
      },
      한국어: {
        genre: "리조트/수영장",
        detail: "수영장과 남국 느낌의 배경으로 사진 찍기 좋은 카페. 여자들끼리의 여행에도 추천합니다.",
        menuFood: "런치 플레이트/디저트",
        menuDrink: "남국 음료/카페 음료",
      },
    },
    type: "food",
    kind: "food",
    status: "映えカフェ",
    genre: "リゾート / プール",
    area: "宮古島",
    detail: "プールや南国感のある背景で写真を撮りやすいカフェ。女子旅にもおすすめです。",
    crowd: "混雑しやすい",
    parking: "あり",
    menu: {
      food: "ランチプレート / スイーツ",
      drink: "南国ドリンク / カフェドリンク",
    },
    instaPostUrl: "https://www.instagram.com/seahorseclub385/",
    baeScore: 5,
    hours: "要確認",
    closed: "要確認",
    categories: ["cafe", "lunch"],
    location: { lat: 24.787, lng: 125.295 },
  },
  {
    name: "gelato cafe Ninufa",
    type: "food", kind: "food", status: "カフェ", genre: "ジェラート / 海カフェ", area: "池間島",
    detail: "池間島で海を眺めながらジェラートを楽しめるカフェ。暑い日のドライブ休憩にもおすすめです。",
    crowd: "入りやすい", parking: "要確認", menu: { food: "ジェラート", drink: "カフェドリンク" },
    hours: "10:00〜17:00", closed: "水曜日",
    instaPostUrl: "https://www.instagram.com/p/DXS9-rckT33/?img_index=7&igsh=MTN4NmdmaXlzbnhmaw==",
    baeScore: 4, categories: ["cafe", "lunch"], location: { lat: 24.9299149, lng: 125.2334789 },
  },
  {
    name: "農家れすとらん 楽園の果実",
    type: "food", kind: "food", status: "ランチ・カフェ", genre: "島食材 / 南国フルーツ", area: "来間島",
    detail: "来間島で島フルーツや島野菜を楽しめる人気店。ランチにもマンゴースイーツ休憩にも使いやすいお店です。",
    crowd: "やや混雑", parking: "あり", menu: { food: "島野菜ランチ / マンゴースイーツ", drink: "トロピカルジュース" },
    hours: "11:00〜18:00", closed: "火曜日",
    instaPostUrl: "https://www.instagram.com/p/DXZJc7QkRug/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 3, categories: ["cafe", "lunch"], location: { lat: 24.7254656, lng: 125.2516224 },
  },
  {
    name: "島茶屋ヤッカヤッカ",
    type: "food", kind: "food", status: "ランチ・カフェ", genre: "古民家カフェ / 島食材", area: "来間島",
    detail: "来間島にある古民家風カフェ。地元食材を使った料理を静かな空間でゆっくり楽しめます。",
    crowd: "入りやすい", parking: "あり", menu: { food: "島食材ランチ", drink: "カフェドリンク" },
    hours: "11:30〜17:00", closed: "なし",
    instaPostUrl: "https://www.instagram.com/p/DPGKivtkw3j/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 1, categories: ["cafe", "lunch"], location: { lat: 24.7229392, lng: 125.2556076 },
  },
  {
    name: "DOUG’S BURGER",
    type: "food", kind: "food", status: "ランチ", genre: "グルメバーガー", area: "平良下里",
    detail: "宮古牛バーガーで知られる人気店。雨の日でもしっかりランチを楽しみたい時におすすめです。",
    crowd: "やや混雑", parking: "要確認", menu: { food: "宮古牛バーガー", drink: "ソフトドリンク" },
    hours: "要確認", closed: "要確認",
    instaPostUrl: "https://www.instagram.com/p/C9XGmvLS4DD/?igsh=bnFpNnlkaXh3OWlm",
    baeScore: 1, categories: ["cafe", "lunch"], location: { lat: 24.7957357, lng: 125.2868122 },
  },
  {
    name: "ブルーシール 宮古島パイナガマ店",
    type: "food", kind: "food", status: "カフェ", genre: "アイスクリーム / スイーツ", area: "パイナガマ周辺",
    detail: "パイナガマビーチ近くにあり、カラフルなアイスやドリンクを楽しめる立ち寄りやすいお店です。",
    crowd: "入りやすい", parking: "要確認", menu: { food: "アイスクリーム", drink: "ドリンク" },
    hours: "要確認", closed: "要確認",
    instaPostUrl: "https://www.instagram.com/p/DaFn7nbgQVg/?igsh=b3FqMjU0amJ0bTNu",
    baeScore: 5, categories: ["cafe", "lunch"], location: { lat: 24.7991282, lng: 125.2691918 },
  },
  {
    name: "ユートピアファーム宮古島",
    type: "food", kind: "food", status: "カフェ", genre: "農園カフェ / 南国フルーツ", area: "上野宮国",
    detail: "南国の花やフルーツに囲まれた農園カフェ。マンゴーやパパイヤのスイーツを楽しめます。",
    crowd: "入りやすい", parking: "あり", menu: { food: "マンゴースムージー / 南国フルーツスイーツ", drink: "フルーツドリンク" },
    hours: "10:00〜18:00", closed: "不定休",
    instaPostUrl: "https://www.instagram.com/p/DZ4iPDRCaac/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 2, categories: ["cafe", "lunch"], location: { lat: 24.738253, lng: 125.322026 },
  },
  {
    name: "SHISA'S CAFE & BBQ",
    type: "food", kind: "food", status: "ランチ・カフェ", genre: "カフェ / BBQ", area: "宮古島本島",
    detail: "南国らしいカラフルな雰囲気のカフェレストラン。友達同士や家族で食事とBBQを楽しみたい時におすすめです。",
    crowd: "入りやすい", parking: "要確認", menu: { food: "カフェメニュー / BBQ", drink: "南国ドリンク" },
    hours: "要確認", closed: "不定休",
    instaPostUrl: "https://www.instagram.com/p/DK9LSSmRpSS/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    baeScore: 5, categories: ["cafe", "lunch"], location: { lat: 24.8205433, lng: 125.279956 },
  },
  {
    name: "島おでん たから",
    i18n: {
      EN: {
        name: "Shima Oden Takara",
        genre: "Island Oden / Okinawan Cuisine",
        detail: "A must-try classic for dinner in Miyakojima. Recommended when you want to slowly savor island oden and Okinawan cuisine.",
        menuFood: "Island oden / Tebichi (pig's feet) / Okinawan cuisine",
        menuDrink: "Awamori / Orion Beer",
      },
      中文: {
        genre: "岛关东煮/冲绳料理",
        detail: "宫古岛晚餐不可错过的经典之选。适合想慢慢品尝岛关东煮和冲绳料理的时候。",
        menuFood: "岛关东煮/猪脚/冲绳料理",
        menuDrink: "泡盛/Orion啤酒",
      },
      한국어: {
        name: "시마오뎅 다카라",
        genre: "섬 오뎅/오키나와 요리",
        detail: "미야코지마 저녁 식사에서 빼놓을 수 없는 단골 후보. 섬 오뎅과 오키나와 요리를 천천히 맛보고 싶을 때 추천합니다.",
        menuFood: "섬 오뎅/데비치(족발)/오키나와 요리",
        menuDrink: "아와모리/오리온 맥주",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "島おでん / 沖縄料理",
    area: "平良",
    detail: "宮古島の夜ご飯で外せない定番候補。島おでんや沖縄料理をゆっくり味わいたい時におすすめです。",
    images: [img("v1789053910/unnamed_kk4eon.webp")],
    crowd: "予約推奨",
    parking: "近隣駐車場を確認",
    menu: {
      food: "島おでん / てびち / 沖縄料理",
      drink: "泡盛 / オリオンビール",
    },
    hours: "18:00〜23:00（日・月定休）",
    closed: "日・月",
    phone: "0980-72-0671",
    address: "〒906-0012 沖縄県宮古島市平良西里172",
    priceRange: "¥2,000〜3,000",
    categories: ["dinner"],
    location: { lat: 24.8029, lng: 125.2794 },
  },
  {
    name: "美ら島",
    i18n: {
      EN: {
        name: "Churashima",
        genre: "Folk Song Izakaya",
        detail: "A restaurant where you can enjoy island songs and a nightlife atmosphere unique to Miyakojima. Great for a night you want to fully enjoy on your trip.",
        menuFood: "Okinawan cuisine / Island cuisine",
        menuDrink: "Awamori / Orion Beer",
      },
      中文: {
        genre: "民谣居酒屋",
        detail: "可以欣赏民谣、感受宫古岛特有夜晚氛围的店铺。适合想尽情享受旅行之夜的日子。",
        menuFood: "冲绳料理/岛料理",
        menuDrink: "泡盛/Orion啤酒",
      },
      한국어: {
        name: "츄라시마",
        genre: "민요 이자카야",
        detail: "섬 노래와 미야코지마다운 밤 분위기를 즐길 수 있는 가게. 여행의 밤을 제대로 즐기고 싶은 날에 추천합니다.",
        menuFood: "오키나와 요리/섬 요리",
        menuDrink: "아와모리/오리온 맥주",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "民謡居酒屋",
    area: "平良",
    detail: "島唄や宮古島らしい夜の雰囲気も楽しめるお店。旅行の夜をしっかり楽しみたい日に。",
    crowd: "かなり混雑",
    parking: "近隣駐車場を確認",
    menu: {
      food: "沖縄料理 / 島料理",
      drink: "泡盛 / オリオンビール",
    },
    hours: "18:00〜23:30",
    closed: "なし",
    phone: "0980-79-9788",
    priceRange: "¥4,000〜8,000",
    instaPostUrl:
      "https://www.instagram.com/p/DaX6W86Tpn4/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8040266, lng: 125.2793683 },
  },
  {
    name: "居酒家 でいりぐち",
    i18n: {
      EN: {
        name: "Izakaya Deiriguchi",
        genre: "Izakaya / Island Food",
        detail: "Recommended when you want to enjoy dinner in Miyakojima at a local-feeling izakaya.",
        menuFood: "Island food / Izakaya menu",
        menuDrink: "Awamori / Orion Beer",
      },
      中文: {
        genre: "居酒屋/岛料理",
        detail: "想在充满当地氛围的居酒屋享用宫古岛晚餐时推荐前往。",
        menuFood: "岛料理/居酒屋菜单",
        menuDrink: "泡盛/Orion啤酒",
      },
      한국어: {
        name: "이자카야 데이리구치",
        genre: "이자카야/섬 음식",
        detail: "현지 느낌이 있는 이자카야에서 미야코지마의 저녁을 즐기고 싶을 때 추천합니다.",
        menuFood: "섬 음식/이자카야 메뉴",
        menuDrink: "아와모리/오리온 맥주",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "居酒屋 / 島ごはん",
    area: "平良",
    detail: "地元感のある居酒屋で宮古島の夜ご飯を楽しみたい時におすすめです。",
    images: [img("v1789053999/kiji1Img_ytpyzu.jpg")],
    crowd: "予約必須",
    parking: "近隣駐車場を確認",
    menu: {
      food: "島ごはん / 居酒屋メニュー",
      drink: "泡盛 / オリオンビール",
    },
    hours: "18:00〜23:00（火定休）",
    closed: "火",
    phone: "0980-79-0197",
    address: "〒906-0013 沖縄県宮古島市平良下里596−1",
    priceRange: "¥3,000〜4,000",
    categories: ["dinner"],
    location: { lat: 24.8032, lng: 125.2802 },
  },
  {
    name: "宮古創作料理 風まかせ",
    i18n: {
      EN: {
        name: "Miyako Creative Cuisine Kazamakase",
        genre: "Izakaya",
        detail: "Run by a couple who love fishing — they'll even cook fish you catch yourself!!",
      },
      中文: {
        genre: "居酒屋",
        detail: "由一对热爱钓鱼的夫妻经营，自己钓到的鱼也可以请店家帮忙烹饪！！",
      },
      한국어: {
        genre: "이자카야",
        detail: "낚시를 아주 좋아하는 부부가 운영하는 가게입니다. 직접 낚은 생선도 요리해 줍니다!!",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "居酒屋",
    area: "平良",
    detail: "釣り大好きなご夫婦がやってるお店です。自分で釣った魚も料理してくれます！！",
    priceRange: "¥4,000〜5,000",
    hours: "17:00〜0:00（火・水定休）",
    closed: "火・水",
    address: "〒906-0012 沖縄県宮古島市平良宇西里299-5 みなせビル103号",
    categories: ["dinner"],
    location: { lat: 24.8036703, lng: 125.2813451 },
  },
  {
    name: "宮古炉端 素燻",
    i18n: {
      EN: {
        name: "Miyako Robata Sukun",
        genre: "Modern Izakaya Restaurant",
        detail: "A Miyako-style robata grill where you can enjoy island seafood, vegetables, and meat dishes!",
      },
      中文: {
        genre: "现代居酒屋餐厅",
        detail: "可以品尝到岛上海鲜、蔬菜和肉类料理的宫古炉端烧！",
      },
      한국어: {
        genre: "모던 이자카야 레스토랑",
        detail: "섬의 해산물과 채소, 고기 요리를 즐길 수 있는 미야코 로바타야키!",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "モダン居酒屋レストラン",
    area: "平良",
    detail: "島の海鮮や野菜にお肉料理が堪能できる宮古炉端！",
    priceRange: "1人あたり ¥6,000〜8,000",
    hours: "火〜日 18:00〜23:00",
    closed: "月曜日",
    phone: "0980-79-0032",
    instaPostUrl:
      "https://www.instagram.com/reel/Dc-MzXIyu7l/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8029986, lng: 125.2825796 },
  },
  {
    name: "地鶏と島野菜 粋蓮",
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "地鶏 / 島野菜 / 居酒屋",
    area: "平良",
    detail: "新鮮な地鶏と島野菜を活かした料理が自慢の、宮古島の地元居酒屋。地鶏の旨みと島の食材を一緒に楽しみたい夜におすすめです。",
    crowd: "予約推奨",
    parking: "要確認",
    menu: {
      food: "地鶏料理 / 島野菜料理",
      drink: "泡盛 / オリオンビール",
    },
    priceRange: "1人あたり ¥4,000〜5,000",
    hours: "毎日 16:00〜1:00",
    closed: "なし",
    phone: "050-5448-6603",
    instaPostUrl:
      "https://www.instagram.com/p/DZMO9PrxuzL/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    mapUrl: "https://maps.app.goo.gl/h4zTgY7ctKNmkkvS7",
    categories: ["dinner"],
    location: { lat: 24.8026991, lng: 125.2790548 },
  },
  {
    name: "居酒屋 南樂",
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "老舗居酒屋 / 島料理",
    area: "平良",
    detail: "長く親しまれている宮古島の老舗居酒屋。宮古島産カツオの旨みをシンプルに味わえる塩タタキがおすすめです。",
    crowd: "予約推奨",
    parking: "要確認",
    menu: {
      food: "宮古島産カツオの塩タタキ",
      drink: "泡盛 / オリオンビール",
    },
    images: [img("v1789054621/unnamed_1_rdzvdp.webp")],
    priceRange: "1人あたり ¥2,000〜5,000",
    hours: "毎日 18:00〜23:30",
    closed: "なし",
    phone: "0980-73-1855",
    mapUrl: "https://maps.app.goo.gl/Uah2pL4xb5WyRsoFA",
    categories: ["dinner"],
    location: { lat: 24.802269, lng: 125.2833357 },
  },
  {
    name: "ツマンデ呑める みやこパーラー ハイサイ!",
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "沖縄料理 / 居酒屋 / 海鮮",
    area: "平良",
    detail: "「半歩進んだOKINAWA FOOD」をテーマに、宮古島の食の魅力を発信する人気店。島の食材を現代風にアレンジした料理を楽しめます。",
    crowd: "予約推奨",
    parking: "なし",
    menu: {
      food: "島の前菜盛り合わせ / カツオヲ漁師だれデ / 土鍋ジューシー",
      drink: "泡盛 / 体験型サワー",
    },
    priceRange: "1人あたり ¥3,000〜5,000",
    hours: "毎日 17:00〜0:00",
    closed: "なし",
    phone: "0980-79-6633",
    address: "〒906-0013 沖縄県宮古島市平良下里601 ちゅらハウス1F",
    instaPostUrl:
      "https://www.instagram.com/p/Cwndy-WPUrK/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.80315, lng: 125.28005 },
  },
  {
    name: "Pork&Fish Dining HULAR",
    type: "food", kind: "food", status: "夜ご飯", genre: "南国ダイニング / しゃぶしゃぶ / 魚介", area: "平良",
    detail: "陽気で元気な南国ダイニング。こだわり出汁のしゃぶしゃぶや魚介料理を楽しめます。",
    crowd: "予約推奨", parking: "要確認",
    menu: { food: "こだわり出汁のしゃぶしゃぶ / 魚介料理", drink: "南国ドリンク / 泡盛" },
    priceRange: "1人あたり ¥3,000〜4,000", hours: "水〜月 17:00〜23:00", closed: "火曜日", phone: "0980-79-0477",
    address: "〒906-0013 沖縄県宮古島市平良下里33",
    instaPostUrl: "https://www.instagram.com/p/Ch1LG-Lv5Vi/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"], location: { lat: 24.8048, lng: 125.2817 },
  },
  {
    name: "わとわ 宮古島店",
    type: "food", kind: "food", status: "夜ご飯", genre: "宮古牛 / 沖縄料理 / 居酒屋", area: "平良",
    detail: "炭火焼き宮古牛と沖縄料理を楽しめる個室完備の居酒屋。全席禁煙で子ども連れにも対応し、電話での事前予約が必須です。",
    crowd: "事前予約必須", parking: "要確認",
    menu: { food: "炭火焼き宮古牛 / 沖縄料理", drink: "泡盛 / オリオンビール" },
    priceRange: "1人あたり ¥3,000〜6,000", hours: "毎日 18:00〜0:00", closed: "なし", phone: "0980-73-7329",
    address: "〒906-0013 沖縄県宮古島市平良下里566-2",
    instaPostUrl: "https://www.instagram.com/p/DTxbdMKkaGv/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"], location: { lat: 24.8037, lng: 125.2798 },
  },
  {
    name: "にんにく焼肉 プルシン宮古島店",
    type: "food", kind: "food", status: "夜ご飯", genre: "黒毛和牛 / にんにく焼肉", area: "平良",
    detail: "宮崎県都城市の黒毛和牛と青森県産にんにくを使用した焼肉店。セルフ飲み放題も楽しめます。",
    crowd: "予約推奨", parking: "近隣駐車場を確認",
    menu: { food: "黒毛和牛のにんにく焼肉", drink: "セルフ飲み放題" },
    priceRange: "1人あたり ¥3,000〜6,000", hours: "月〜水・金・日 11:30〜14:00 / 17:00〜23:00、木・土 17:00〜23:00", closed: "なし", phone: "0980-79-5529",
    address: "〒906-0013 沖縄県宮古島市平良下里83-3",
    instaPostUrl: "https://www.instagram.com/p/DOIeKBAAdZn/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"], location: { lat: 24.805, lng: 125.2825 },
  },
  {
    name: "ホルモン人 宮古島本店",
    type: "food", kind: "food", status: "夜ご飯", genre: "焼肉 / ホルモン", area: "平良",
    detail: "コストパフォーマンスよく焼肉とホルモンを楽しめる宮古島本店。",
    crowd: "予約推奨", parking: "要確認", menu: { food: "焼肉 / ホルモン", drink: "ビール / 泡盛" },
    priceRange: "1人あたり ¥3,000〜6,000", hours: "毎日 17:30〜23:00", closed: "なし", phone: "0980-73-2911",
    address: "〒906-0013 沖縄県宮古島市平良下里596-1",
    instaPostUrl: "https://www.instagram.com/p/CpuOTfivKfj/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"], location: { lat: 24.8032, lng: 125.2802 },
  },
  {
    name: "宮古酒場イツモノトコ。",
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "昭和レトロ酒場 / 居酒屋",
    area: "平良",
    detail: "昭和レトロな雰囲気の中で、深夜から朝方まで楽しめる宮古酒場。毎日朝4時まで営業しているため、遅い時間の食事や二軒目にも利用できます。",
    crowd: "予約推奨",
    parking: "要確認",
    menu: { food: "居酒屋料理", drink: "ビール / 泡盛 / 各種酒" },
    priceRange: "1人あたり ¥3,000〜4,000",
    hours: "毎日 19:00〜4:00",
    closed: "なし",
    phone: "080-4270-8708",
    address: "〒906-0013 沖縄県宮古島市平良下里646-2 バロック・ビル3-B",
    instaPostUrl: "https://www.instagram.com/reel/DXRh0uQE4iX/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8019, lng: 125.2814 },
  },
  {
    name: "北琉笑店 いころ",
    i18n: {
      EN: {
        name: "Hokuryu Shoten Ikoro",
        genre: "Seafood Izakaya",
      },
      中文: {
        genre: "海鲜居酒屋",
      },
      한국어: {
        genre: "해산물 이자카야",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "海鮮居酒屋",
    area: "平良",
    crowd: "予約推奨",
    priceRange: "1人あたり¥2,000〜6,000",
    hours: "18:00〜0:00（木定休）",
    closed: "木",
    phone: "0980-75-4108",
    address: "〒906-0000 沖縄県宮古島市平良西里146",
    instaPostUrl:
      "https://www.instagram.com/p/C-G51sOyHEA/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.805062, lng: 125.2793232 },
  },
  {
    name: "海鮮 炭火 ABURI",
    i18n: {
      EN: { name: "Kaisen Sumibi ABURI" },
      中文: {},
      한국어: {},
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "海鮮炭火焼き",
    area: "平良",
    detail: "全国各地の新鮮な海鮮を宮古島でいつでも楽しめるお店。",
    crowd: "予約推奨",
    priceRange: "¥4,000〜5,000",
    hours: "18:00〜0:00（水定休）",
    closed: "水",
    phone: "0980-79-6715",
    address: "〒906-0000 沖縄県宮古島市平良西里150-2",
    instaPostUrl:
      "https://www.instagram.com/p/Dc3OqmnmQxc/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8052658, lng: 125.2787812 },
  },
  {
    name: "うまりずま",
    i18n: {
      EN: {
        name: "Umarizuma",
        genre: "Folk Song Izakaya",
        detail: "A dinner spot centered on island and Okinawan cuisine, easy to visit with friends.",
        menuFood: "Okinawan cuisine / Island cuisine",
        menuDrink: "Awamori / Orion Beer",
      },
      中文: {
        genre: "民谣居酒屋",
        detail: "以岛料理和冲绳料理为主，方便和朋友一起前往的晚餐去处。",
        menuFood: "冲绳料理/岛料理",
        menuDrink: "泡盛/Orion啤酒",
      },
      한국어: {
        name: "우마리즈마",
        genre: "민요 이자카야",
        detail: "섬 요리와 오키나와 요리를 중심으로, 친구들끼리도 편하게 갈 수 있는 저녁 식사 스팟입니다.",
        menuFood: "오키나와 요리/섬 요리",
        menuDrink: "아와모리/오리온 맥주",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "民謡居酒屋",
    area: "平良",
    detail: "島料理や沖縄料理を中心に、友達同士でも入りやすい夜ご飯スポットです。",
    crowd: "予約推奨",
    parking: "近隣駐車場を確認",
    menu: {
      food: "沖縄料理 / 島料理",
      drink: "泡盛 / オリオンビール",
    },
    hours: "17:00〜23:00（月定休）",
    closed: "月",
    phone: "0980-79-0335",
    address: "〒906-0013 沖縄県宮古島市平良西里303",
    priceRange: "¥2,000〜5,000",
    instaPostUrl:
      "https://www.instagram.com/reel/DT199YOkd5g/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8022, lng: 125.2809 },
  },
  {
    name: "宮古牛の焼肉 喜八",
    i18n: {
      EN: {
        name: "Yakiniku Kihachi",
        genre: "Miyako Beef / Yakiniku",
        detail: "Recommended for a night you want to eat Miyako beef. A yakiniku restaurant that's easy to make into a special dinner.",
        menuFood: "Miyako beef / Yakiniku",
        menuDrink: "Beer / Wine",
      },
      中文: {
        genre: "宫古牛/烤肉",
        detail: "想吃宫古牛的夜晚推荐。是容易营造特别感的烤肉店。",
        menuFood: "宫古牛/烤肉",
        menuDrink: "啤酒/葡萄酒",
      },
      한국어: {
        name: "야키니쿠 기하치",
        genre: "미야코규/야키니쿠",
        detail: "미야코규를 먹고 싶은 밤에 추천합니다. 특별한 느낌의 디너로 만들기 좋은 야키니쿠 전문점입니다.",
        menuFood: "미야코규/야키니쿠",
        menuDrink: "맥주/와인",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "宮古牛 / 焼肉",
    area: "平良",
    detail: "宮古牛を食べたい夜におすすめ。特別感のあるディナーにしやすい焼肉店です。",
    crowd: "予約推奨",
    parking: "要確認",
    menu: {
      food: "宮古牛 / 焼肉",
      drink: "ビール / ワイン",
    },
    priceRange: "1人あたり ¥5,000〜10,000",
    hours: "火〜日 18:00〜23:00",
    closed: "月曜日",
    phone: "0980-73-3859",
    instaPostUrl:
      "https://www.instagram.com/p/CZl99KOlHYy/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8039, lng: 125.2823 },
  },
  {
    name: "沖縄やんばるアグーしゃぶしゃぶ 嘉福",
    i18n: {
      EN: {
        name: "Shabu-shabu Kafuku",
        genre: "Shabu-shabu",
        detail: "A shabu-shabu restaurant easy to use for a calm dinner. Recommended for a day you want to eat slowly.",
        menuFood: "Shabu-shabu / Japanese cuisine",
        menuDrink: "Beer / Sake",
      },
      中文: {
        genre: "涮涮锅",
        detail: "适合安静晚餐的涮涮锅店。适合想悠闲用餐的日子。",
        menuFood: "涮涮锅/日式料理",
        menuDrink: "啤酒/清酒",
      },
      한국어: {
        name: "샤부샤부 가후쿠",
        genre: "샤부샤부",
        detail: "차분한 저녁 식사에 이용하기 좋은 샤부샤부 전문점. 여유롭게 식사하고 싶은 날 추천합니다.",
        menuFood: "샤부샤부/일식",
        menuDrink: "맥주/사케",
      },
    },
    type: "food",
    kind: "food",
    status: "夜ご飯",
    genre: "しゃぶしゃぶ",
    area: "平良",
    detail: "沖縄の銘柄豚「アグー豚」を、ハマグリと雪塩を使用した出汁で味わえる絶品しゃぶしゃぶ。事前予約必須です。",
    crowd: "事前予約必須",
    parking: "要確認",
    menu: {
      food: "アグー豚のしゃぶしゃぶ",
      drink: "ビール / 日本酒",
    },
    priceRange: "1人あたり ¥5,000〜9,000",
    hours: "月・火・木〜日 16:00〜0:00 / 水 16:00〜23:00",
    closed: "なし",
    phone: "0980-79-6575",
    instaPostUrl:
      "https://www.instagram.com/reel/C-R3LgkP9rE/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["dinner"],
    location: { lat: 24.8018, lng: 125.279 },
  },
  {
    name: "マッスルバー",
    i18n: {
      EN: {
        name: "Muscle Bar",
        genre: "Bar / Muscle Show",
        detail: "Watch top-class muscle performance entertainment. Recommended for anyone who wants to fully enjoy Miyakojima nightlife. Surprise shows and group reservations are also available.",
        menuDrink: "60-min all-you-can-drink ¥3,000",
      },
      中文: {
        genre: "酒吧/肌肉秀",
        detail: "欣赏各种肌肉表演带来的极致娱乐。想在宫古岛尽情享受夜生活的人推荐前往，也可安排惊喜表演和团体预约。",
        menuDrink: "60分钟畅饮3000日元",
      },
      한국어: {
        name: "머슬 바",
        genre: "바/근육쇼",
        detail: "다양한 근육 퍼포먼스로 펼치는 최고의 엔터테인먼트를 감상하세요. 미야코지마에서 신나게 밤을 즐기고 싶은 분께 추천하며, 서프라이즈 연출과 단체 예약도 가능합니다.",
        menuDrink: "60분 무제한 음료 3,000엔",
      },
    },
    type: "food",
    kind: "food",
    status: "夜遊び",
    genre: "マッスルバー / エンタメ",
    area: "平良",
    detail: "各種マッスルパフォーマンスによる最高のエンタメを披露。宮古島で思いっきり夜遊びしたい方は是非。サプライズ演出や団体予約も可能です。",
    crowd: "予約不要",
    parking: "なし",
    menu: {
      food: "",
      drink: "60分飲み放題3000円",
    },
    hours: "21:00〜",
    closed: "なし",
    phone: "07050634671",
    instaPostUrl:
      "https://www.instagram.com/reel/DWtbZ2MD_Ct/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
    categories: ["nightlife"],
    location: { lat: 24.8025, lng: 125.2815 },
  },
  {
    name: "レーベの村",
    i18n: {
      EN: {
        name: "Rebe no Mura",
        genre: "Bar",
        detail: "A relaxed nightlife bar in Miyakojima, no reservation needed. Sound quality isn't great.",
      },
      中文: {
        name: "Rebe no Mura",
        genre: "酒吧",
        detail: "宫古岛的休闲夜生活酒吧，无需预约即可轻松前往。音质不算好。",
      },
      한국어: {
        name: "레베노무라",
        genre: "바",
        detail: "예약 없이 편하게 들를 수 있는 미야코지마의 나이트라이프 바입니다. 음질은 좋지 않습니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "夜遊び",
    genre: "BAR",
    area: "平良",
    detail: "予約不要で気軽に立ち寄れる夜遊びスポット。音は良くない。",
    crowd: "予約不要",
    parking: "あり（台数少なめ）",
    hours: "20:00〜24:00",
    closed: "なし",
    phone: "090-4473-6731",
    address: "沖縄県宮古島市平良松原884-1",
    instaPostUrl:
      "https://www.instagram.com/reel/DWbRuGZk3lp/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["nightlife"],
    location: { lat: 24.807, lng: 125.283 },
  },
  {
    name: "PLANET",
    i18n: {
      EN: {
        genre: "Pizza Bar",
        detail: "A pizza bar with 2 private karaoke rooms (up to 10 people). VIP room ¥5,000/hour.",
      },
      中文: {
        genre: "披萨酒吧",
        detail: "备有2间卡拉OK包间（最多10人）的披萨酒吧。VIP包间每小时5,000日元。",
      },
      한국어: {
        genre: "피자 바",
        detail: "노래방 개인룸 2개 완비（최대 10명）된 피자 바입니다. VIP룸은 시간당 5,000엔입니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "夜遊び",
    genre: "ピザバー",
    area: "宮古島",
    detail: "カラオケ個室2部屋完備（〜10人）。VIP roomは1時間5,000円。",
    crowd: "要確認",
    parking: "要確認",
    hours: "20:00〜",
    closed: "なし",
    address: "沖縄県宮古島市下里567-1 星の王子様2階",
    instaPostUrl:
      "https://www.instagram.com/reel/CnJ8rXqB174/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["nightlife"],
    location: { lat: 24.804, lng: 125.282 },
  },
  {
    name: "煙突屋",
    i18n: {
      EN: {
        name: "Entotsuya",
        genre: "Shisha Bar",
        detail: "A hideaway shisha cafe & bar in Miyakojima🕌. Stylish chill-out space with many flavors to choose from. Private bookings from 2 hours are also available.",
        menuDrink: "Charge ¥500 / Drinks from ¥500 / Shisha ¥2,500",
      },
      中文: {
        name: "烟囱屋",
        genre: "水烟吧",
        detail: "宫古岛的隐藏水烟咖啡厅&酒吧🕌。时尚的chill空间，口味选择丰富。也可包场2小时起。",
        menuDrink: "入场费500日元 / 饮品500日元起 / 水烟2,500日元",
      },
      한국어: {
        name: "엔토츠야",
        genre: "시샤 바",
        detail: "미야코지마의 아지트 같은 시샤 카페&바🕌. 세련된 칠 공간에 다양한 플레이버가 준비되어 있습니다. 2시간부터 대관도 가능합니다.",
        menuDrink: "차지 500엔 / 음료 500엔〜 / 시샤 2,500엔",
      },
    },
    type: "food",
    kind: "food",
    status: "夜遊び",
    genre: "シーシャバー",
    area: "平良",
    detail: "宮古島の隠れ家シーシャCafe&Bar煙突屋🕌。お洒落なchill空間で、フレーバーも多数。貸切2h〜可能です。",
    crowd: "入りやすい",
    parking: "なし",
    menu: {
      food: "",
      drink: "チャージ500円 / ドリンク500円〜 / シーシャ2,500円",
    },
    hours: "19:00〜LAST",
    closed: "要確認",
    phone: "0980-79-5500",
    address: "宮古島市平良下里52-2 ディープブルービル101",
    mapQuery: "宮古島市平良下里52-2 ディープブルービル101",
    instaPostUrl:
      "https://www.instagram.com/p/DUVXZKhkvzD/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["nightlife"],
    location: { lat: 24.8035, lng: 125.2825 },
  },
  {
    name: "果実屋",
    i18n: {
      EN: {
        genre: "Bar",
        detail: "Miyakojima's first‼︎ A bar & night cafe☕️ specializing in sweets and fruit cocktails. We're committed to homemade, fruit-focused drinks — a one-of-a-kind spot in Miyakojima.",
        menuDrink: "Fruit cocktails",
      },
      中文: {
        genre: "酒吧",
        detail: "宫古岛首创‼︎ 专门提供甜点与水果鸡尾酒的酒吧＆深夜咖啡厅☕️。坚持自家制作与新鲜水果，是宫古岛独一无二的店铺。",
        menuDrink: "水果鸡尾酒",
      },
      한국어: {
        genre: "바",
        detail: "미야코지마 최초‼︎ 디저트와 과일 칵테일 전문 바＆심야 카페☕️. 수제와 과일에 신경 쓴, 미야코지마에서 유일무이한 가게입니다.",
        menuDrink: "과일 칵테일",
      },
    },
    type: "food",
    kind: "food",
    status: "夜遊び",
    genre: "バー",
    area: "宮古島",
    detail: "宮古島初‼︎ スイーツとフルーツカクテル専門のBAR&夜カフェ☕️。当店は自家製とフルーツにこだわった宮古島で唯一無二のお店です。",
    crowd: "入りやすい",
    menu: {
      food: "",
      drink: "フルーツを使ったカクテル",
    },
    hours: "20:00〜（20:00・20:30のみ予約可）",
    closed: "月",
    phone: "090-2127-1000",
    address: "沖縄県宮古島市西里153-3",
    instaPostUrl:
      "https://www.instagram.com/p/CsGsapzPdl6/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
    categories: ["nightlife"],
    location: { lat: 24.805, lng: 125.281 },
  },
  {
    name: "すばや 大和",
    i18n: {
      EN: {
        name: "Subaya Yamato",
        genre: "Okinawa Soba (Late Night)",
        detail: "Okinawa soba to finish off the night, open until 5am.",
      },
      中文: {
        name: "Subaya 大和",
        genre: "冲绳荞麦面（深夜）",
        detail: "深夜也能吃到的冲绳荞麦面，营业至凌晨5点。",
      },
      한국어: {
        name: "스바야 야마토",
        genre: "오키나와 소바(심야)",
        detail: "심야에 즐기는 오키나와 소바, 새벽 5시까지 영업합니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "沖縄そば",
    area: "平良",
    detail: "深夜5時まで〆の沖縄そば。",
    hours: "21:00〜5:00",
    phone: "050-5494-4773",
    address: "沖縄県宮古島市平良下里556",
    instaPostUrl:
      "https://www.instagram.com/reel/DK1jvO6SPON/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["lateNightMeal"],
    location: { lat: 24.8065, lng: 125.2835 },
  },
  {
    name: "麺や 大和",
    i18n: {
      EN: {
        name: "Menya Yamato",
        genre: "Ramen Izakaya",
        detail: "A ramen izakaya open until 3am.",
      },
      中文: {
        name: "面屋 大和",
        genre: "拉面酒场",
        detail: "营业至凌晨3点的拉面酒场。",
      },
      한국어: {
        name: "멘야 야마토",
        genre: "라멘 이자카야",
        detail: "새벽 3시까지 영업하는 라멘 이자카야입니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "ラーメン酒場",
    area: "平良",
    detail: "深夜3時までのラーメン酒場。",
    hours: "18:00〜3:00",
    phone: "050-8892-0077",
    address: "沖縄県宮古島市平良西里143-1",
    instaPostUrl:
      "https://www.instagram.com/p/DKwdkCwSPJY/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["lateNightMeal"],
    location: { lat: 24.804, lng: 125.2795 },
  },
  {
    name: "魚天",
    i18n: {
      EN: {
        name: "Uoten",
        genre: "Seafood Izakaya",
        detail: "Seafood × home-style dishes, open until 4am. Enjoy fresh seafood like sashimi and simmered dishes, plus fried chicken and set meals too.",
      },
      中文: {
        genre: "海鲜居酒屋",
        detail: "海鲜×家常菜，营业至凌晨4点。可品尝生鱼片、炖煮等新鲜海鲜料理，also备有炸鸡和套餐。",
      },
      한국어: {
        genre: "해산물 이자카야",
        detail: "해산물×가정식, 새벽 4시까지 영업. 회, 조림 등 신선한 해산물 메뉴는 물론 가라아게와 정식도 준비되어 있습니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "海鮮居酒屋",
    area: "平良",
    detail: "海鮮×おばんざい×深夜4時まで。新鮮な海鮮料理を楽しめる居酒屋。刺身や煮付けなどの海鮮メニューはもちろん、唐揚げや定食も揃っています。",
    hours: "18:00〜4:00（L.O.3:00）",
    phone: "050-5489-3006",
    address: "沖縄県宮古島市平良西里82-1 D-HONEY 1F",
    categories: ["lateNightMeal"],
    location: { lat: 24.8035, lng: 125.2805 },
  },
  {
    name: "MARUGO肉バル",
    i18n: {
      EN: {
        name: "MARUGO Meat Bar",
        genre: "Okinawa Beef Steak & Pizza",
        detail: "A grown-up gourmet spot open from 18:00 to 4am, serving Okinawa-grown wagyu steak and freshly baked pizza.",
      },
      中文: {
        genre: "冲绳和牛牛排×现烤披萨",
        detail: "18点营业至凌晨4点的成人美食地点，可享用冲绳县产和牛牛排与现烤披萨。",
      },
      한국어: {
        genre: "오키나와 와규 스테이크×즉석 피자",
        detail: "18시부터 새벽 4시까지 영업하는 어른의 맛집. 오키나와산 와규 스테이크와 즉석에서 구운 피자를 즐길 수 있습니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "肉バル",
    area: "平良",
    detail: "18時から深夜4時まで営業する大人のグルメスポット。県産和牛ステーキと焼きたてピザが楽しめます。",
    hours: "18:00〜4:00",
    phone: "0980-79-6939",
    address: "沖縄県宮古島市平良下里646-2 バロックビル1F",
    categories: ["lateNightMeal"],
    location: { lat: 24.807, lng: 125.284 },
  },
  {
    name: "ピッツァバル",
    i18n: {
      EN: {
        name: "Pizza Bar",
        genre: "Wood-Fired Pizza",
        detail: "Authentic wood-fired pizza baked by a craftsman. Open from 19:00 to around 3am.",
      },
      中文: {
        genre: "柴窑披萨",
        detail: "职人手工柴窑烘烤的正宗披萨。19点营业至凌晨3点左右。",
      },
      한국어: {
        genre: "장작 화덕 피자",
        detail: "장인이 굽는 정통 장작 화덕 피자. 19시부터 새벽 3시경까지 영업합니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "本格薪窯ピッツァ",
    area: "平良",
    detail: "職人が焼く本格薪窯ピッツァ。19時から深夜3時頃まで営業。",
    hours: "19:00〜3:00頃",
    phone: "0980-79-6577",
    address: "沖縄県宮古島市平良下里5 N.TKビル1階",
    categories: ["lateNightMeal"],
    location: { lat: 24.806, lng: 125.2815 },
  },
  {
    name: "貝出汁〆そば名月",
    i18n: {
      EN: {
        name: "Kaidashi Shime-soba Meigetsu",
        genre: "Shellfish Broth Ramen",
        detail: "Uses fresh noodles from Hisamatsu Noodle Factory in Miyakojima, in a shellfish broth soup made with clams like hamaguri and asari.",
      },
      中文: {
        genre: "贝类高汤拉面",
        detail: "使用宫古岛久松制面所的生面，搭配文蛤、蛤蜊等贝类熬制的高汤。",
      },
      한국어: {
        genre: "조개육수 라멘",
        detail: "미야코지마 히사마쓰 제면소의 생면을 사용하며, 대합・바지락 등 조개육수 국물이 특징입니다.",
      },
    },
    type: "food",
    kind: "food",
    status: "〆ご飯",
    genre: "貝出汁そば",
    area: "平良",
    detail: "宮古島の久松製麺所の生麺を使用。ハマグリやアサリの貝出汁スープが特徴です。",
    hours: "19:00〜3:00",
    phone: "070-9084-1159",
    address: "〒906-0013 沖縄県宮古島市平良下里61-1",
    instaPostUrl:
      "https://www.instagram.com/p/DThnf1egV5M/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
    categories: ["lateNightMeal"],
    location: { lat: 24.8055, lng: 125.283 },
  },
];
